<template>
  <div class="mt-8">
    <div class="flex flex-wrap items-center justify-between gap-4">
      <h2>{{ title }}</h2>
      <div class="flex items-center gap-3">
        <date-picker :value="year" @change="setDate" picker="year" :allowClear="false" />

        <CustumSelect
          name="type"
          placeholder="select type "
          :data="typeData"
          :defaultData="1"
          :rules="{
            required: false,
          }"
          @setInput="setInput"
        />
      </div>
    </div>
    <div
      v-if="queryObj && (queryObj.isFetching || queryObj.isLoading)"
      class="flex items-center justify-center py-16"
    >
      <Spin spinning size="large" />
    </div>
    <Empty v-if="!chartData && !queryObj?.isFetching && !queryObj?.isLoading" />

    <QueryAlert :query="queryObj" />
    <div class="mt-6 min-w-[700px] overflow-x-auto" v-if="chartData">
      <BarChart :chartData="chartData" :plugins="[textPlugin, labelCenterPlugin, legendPlugin]" />
    </div>
    <div class="mt-4 flex items-center gap-1 text-white" v-if="type == 2 && chartData">
      <span
        class="bg-primary-light hover:bg-primary h-7 px-4 rounded flex cursor-pointer items-center justify-center"
        @click="prevWeek"
        @keydown.enter="prevWeek"
      >
        <PhArrowLeft weight="bold" size="18" />
      </span>
      <span
        class="bg-primary-light h-7 flex-grow font-bold px-4 rounded flex items-center justify-center"
      >
        {{ weekRangeStart }} - {{ weekRangeEnd }}
      </span>
      <span
        class="bg-primary-light hover:bg-primary h-7 px-4 rounded flex cursor-pointer items-center justify-center"
        @click="nextWeek"
        @keydown.enter="nextWeek"
      >
        <PhArrowRight weight="bold" size="18" />
      </span>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import CustumSelect from '@/components/shared/form/CustumSelect.vue';
import { DatePicker, Empty, Spin } from 'ant-design-vue';

import QueryAlert from '@/components/shared/QueryAlert.vue';

import BarChart from '../../shared/BarChart.vue';
import { PhArrowLeft, PhArrowRight } from 'phosphor-vue';

export default {
  components: {
    CustumSelect,
    BarChart,
    DatePicker,
    Spin,
    QueryAlert,
    PhArrowLeft,
    PhArrowRight,
    Empty,
  },
  props: {
    queryname: String,
    gettername: String,
    year: Object,
    week: Number,
    title: String,
    filter: String,
    commutersData: Object,
    initialData: Object,
  },

  data() {
    return {
      type: 1,
      typeData: [
        {
          id: 1,
          name: 'Monthly',
        },
        {
          id: 2,
          name: 'Weekly',
        },
      ],
    };
  },

  methods: {
    setInput(val) {
      if (val.type && val.type.value) {
        this.type = val.type.value;
        if (val.type.value === 1) {
          this.$emit('setType', 'monthly');
        } else {
          this.$emit('setType', 'weekly');
          this.$emit('setWeek', 1);
        }
      }
    },
    setDate(y) {
      this.$emit('setWeek', 1);
      this.$emit('setDate', y);
    },
    prevWeek() {
      if (this.week != 0) this.$emit('setWeek', this.week - 1);
    },
    nextWeek() {
      this.$emit('setWeek', this.week + 1);
    },
  },
  computed: {
    queryObj() {
      return this.$store.state.stats[this.queryname];
    },
    queryData() {
      return this.$store.getters[this.gettername];
    },
    chartPlugins() {
      if (this.queryData) {
        if (this.type === 1) {
          const labels = {
            value: {
              // Label at center
              anchor: 'center',
              align: 'center',
              color: '#ffffff',
              font: {
                weight: 'bold',
                size: 16,
              },
              formatter: function (value) {
                return `${value.toFixed(2)}`;
              },
            },
            commuters: {
              // Label at center
              anchor: 'end',
              align: 'end',
              color: '#000',
              font: {
                weight: 'bold',
                size: 16,
              },
              formatter: function (value, context) {
                return `${context.dataset?.users_count[context.dataIndex]} Commuters`;
              },
            },
          };
          return {
            datalabels: { labels },
          };
        } else {
          const labels = {
            value: {
              // Label at center
              anchor: 'center',
              align: 'center',
              color: '#ffffff',
              font: {
                weight: 'bold',
                size: 16,
              },
              formatter: function (value) {
                return `${value.toFixed(2)}`;
              },
            },
            commuters: {
              // Label at center
              anchor: 'end',
              align: 'end',
              color: '#000',
              font: {
                weight: 'bold',
                size: 16,
              },
              formatter: function (value, context) {
                return `${context.dataset?.users_count[context.dataIndex]} Commuters`;
              },
            },
          };
          return {
            datalabels: { labels },
          };
        }
      } else {
        return null;
      }
    },
    chartData() {
      if (this.queryData) {
        if (this.type === 1) {
          const monthLabels = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
          ];
          const visualizeData = {
            labels: monthLabels,
            datasets: [
              {
                label: 'Average commute distance per trip (miles per trip)',
                data: [...monthLabels.map((v) => this.queryData?.[v]?.value ?? 0)],
                users_count: [...monthLabels.map((v) => this.queryData?.[v]?.users_count ?? 0)],
                backgroundColor: ['#278c64'],
              },
            ],
          };
          return visualizeData;
        } else {
          const monthLabels = Object.keys(this?.queryData ?? {});
          const visualizeData = {
            labels: monthLabels,
            datasets: [
              {
                label: 'Average commute distance per trip (miles per trip)',
                data: [...monthLabels.map((v) => this.queryData?.[v]?.value ?? 0)],
                users_count: [...monthLabels.map((v) => this.queryData?.[v]?.users_count ?? 0)],
                backgroundColor: ['#278c64'],
              },
            ],
          };
          return visualizeData;
        }
      } else {
        return null;
      }
    },
    weekRangeStart() {
      return Object.keys(this?.queryData ?? {})[0];
    },
    weekRangeEnd() {
      const keys = Object.keys(this?.queryData ?? {});
      if (keys.length) return keys[keys.length != 0 ? keys.length - 1 : 0];
      else return null;
    },
    textPlugin() {
      const app = this;

      //
      return {
        id: 'bars-above-circle',
        afterDraw(chart) {
          const {
            ctx,
            // eslint-disable-next-line no-unused-vars
            chartArea: { top, bottom, left, right, width, height },
          } = chart;
          const dataIndex = chart.data.datasets.length - 1;

          chart.getDatasetMeta(dataIndex).data.forEach((datapoints, inx) => {
            const { x, y: defY } = datapoints.tooltipPosition();

            let y = defY;

            // eslint-disable-next-line eqeqeq
            if (!datapoints.height) {
              //
              for (let i = dataIndex - 1; i >= 0; i -= 1) {
                const cdp = chart.getDatasetMeta(i).data[inx];
                // eslint-disable-next-line eqeqeq
                if (cdp.height) {
                  y = cdp.y;
                  break;
                }
              }
            }

            let count = 0;

            // commutersData

            chart.data.datasets.forEach((d) => {
              // count += +d.defaultData[inx] || 0;
              count += +d.users_count[inx] || 0;
            });

            // console.log('COUNT', count);
            ctx.fillStyle = 'gray';
            ctx.fillRect(x, y, 2, 2);

            // draw line
            ctx.beginPath();
            ctx.moveTo(x, y);
            ctx.lineTo(x, y - 10);
            ctx.strokeStyle = 'gray';
            ctx.stroke();
            // ctx.lineTo(x, yLine);
            ctx.beginPath();
            ctx.arc(x, y - 28, 20, 0, 2 * Math.PI, false);

            ctx.strokeStyle = 'gray';
            ctx.stroke();
            // const isFar = x / width < 0.3 || x / width > 0.7;

            ctx.font = '0.85rem sans-serif';
            ctx.fillStyle = 'black';
            ctx.textBaseline = 'middle';
            ctx.textAlign = 'center';
            ctx.fillText(count, x, y - 26);
          });

          ctx.restore();

          ctx.save();
        },
      };
    },
    labelCenterPlugin() {
      return {
        id: 'insideTextPlugin',
        afterDraw(chart) {
          const {
            ctx,
            // eslint-disable-next-line no-unused-vars
            chartArea: { top, bottom, left, right, width, height },
          } = chart;

          chart.data.datasets.forEach((dataset, ix) => {
            chart.getDatasetMeta(ix).data.forEach((datapoints, inx) => {
              const { x, y } = datapoints.tooltipPosition();

              const topPos = datapoints.height / 2;

              // eslint-disable-next-line no-unused-vars
              const color = dataset.backgroundColor[inx];
              const textNum = dataset.data[inx] ? (dataset.data[inx] * 10) / 10 : 0;

              const text = textNum.toFixed(2);

              // eslint-disable-next-line eqeqeq
              if (textNum != 0 && datapoints.height && datapoints.height > 14) {
                ctx.font = '0.85rem sans-serif';
                ctx.fillStyle = 'white';
                ctx.textBaseline = 'middle';
                ctx.textAlign = 'center';
                ctx.fillText(text, x, y + topPos);
              }
            });
          });

          ctx.restore();

          ctx.save();
        },
      };
    },
    legendPlugin() {
      return {
        id: 'extraLegendMargin',
        beforeInit(chart) {
          const originalFit = chart.legend.fit;
          chart.legend.fit = function fit() {
            originalFit.bind(chart.legend)();
            this.height += 40; // increase the space between legend and chart
          };
        },
      };
    },
  },
};
</script>
